<div class="button-box">
    <cui-button class="btn_style_sm print-hide btn_abrir" (click)="showBuscador()">
        {{ textoBoton }}
    </cui-button>
</div>
<div class="buscador-content" *ngIf="buscadorOpen">
    <form [formGroup]="buscadorForm" class="buscador">
        <div class="wrapper">
            <ul>
                <li>
                    <input
                        type="text"
                        [formControlName]="'rut'"
                        name="rut"
                        class="form-control"
                        placeholder="{{ identificadorUsuarioLabel }} ej: {{ identificadorUsuarioEjemplo }}"
                    />
                </li>
                <li>
                    <input
                        type="text"
                        [formControlName]="'nombre'"
                        name="nombre"
                        class="form-control"
                        placeholder="Nombre"
                    />
                </li>
                <li>
                    <input
                        type="text"
                        [formControlName]="'apellido_paterno'"
                        name="apellido_paterno"
                        class="form-control"
                        placeholder="Apellido paterno"
                    />
                </li>
                <li>
                    <input
                        type="text"
                        [formControlName]="'apellido_materno'"
                        name="apellido_materno"
                        class="form-control"
                        placeholder="Apellido materno"
                    />
                </li>
                <li>
                    <cui-button-link class="btn_style btn_search" (click)="search()">
                        <fa name="search"></fa>
                        &nbsp;Buscar
                    </cui-button-link>
                </li>
                <li>
                    <cui-button-link class="btn_style btn_clear" (click)="cleanData()">
                        <fa name="search"></fa>
                        &nbsp;Limpiar datos
                    </cui-button-link>
                </li>
            </ul>
        </div>
        <div class="extra-filters">
            <div class="con_respuestas">
                <legend class="title-extra-filters">Filtros extras</legend>
                <div class="radio">
                    <label>
                        <input type="radio" [formControlName]="'con_respuestas'" [value]="true" name="con_respuestas" />
                        {{ "estadisticas.graficos.trepa_buscador.con_respuestas" | t }}
                    </label>
                </div>

                <div class="radio">
                    <label>
                        <input
                            type="radio"
                            [formControlName]="'con_respuestas'"
                            [value]="false"
                            name="con_respuestas"
                        />
                        {{ "estadisticas.graficos.trepa_buscador.sin_respuestas" | t }}
                    </label>
                </div>

                <div class="radio">
                    <label>
                        <input type="radio" [formControlName]="'con_respuestas'" [value]="null" name="con_respuestas" />
                        {{ "estadisticas.graficos.trepa_buscador.todos" | t }}
                    </label>
                </div>
            </div>
        </div>
    </form>
</div>
